import { Injectable } from '@angular/core';
import { ColumnService } from '../column/column.service';
var ReadonlyService = /** @class */ (function () {
    function ReadonlyService(columnService) {
        this.columnService = columnService;
    }
    ReadonlyService.prototype.getValue = function (componentName, col, val, mode) {
        col = this.setOptions(componentName, col);
        if (typeof val === 'undefined' || val === null) {
            val = '';
        }
        if (col.controlType === 'label' && !col.key) {
            val = col.label;
        }
        else if (col.controlType === 'number' && col.params && col.params.numberFormat && typeof val === 'number') {
            var numberFormat = col.params.numberFormat;
            if (typeof numberFormat.locales !== 'undefined') {
                val = new Intl.NumberFormat(numberFormat.locales, numberFormat.options).format(val);
            }
            else {
                val = new Intl.NumberFormat(numberFormat.options).format(val);
            }
        }
        else if ((col.controlType === 'select' || col.controlType === 'select2' || col.controlType === 'radio') && col.params && col.params.options) {
            for (var _i = 0, _a = col.params.options; _i < _a.length; _i++) {
                var option = _a[_i];
                if (option.code.toString() === val.toString()) {
                    val = option.display;
                    break;
                }
            }
        }
        else if (col.controlType === 'checkbox' && col.params && col.params.options) {
            var vals = [];
            for (var _b = 0, _c = col.params.options; _b < _c.length; _b++) {
                var option = _c[_b];
                for (var _d = 0, val_1 = val; _d < val_1.length; _d++) {
                    var v = val_1[_d];
                    if (option.code.toString() === v.toString()) {
                        vals.push(option.display);
                    }
                }
            }
            if (mode === 'readonly') {
                val = vals;
            }
            else {
                val = vals.join(', ');
            }
        }
        else if (col.controlType === 'oneCheckbox' && col.params) {
            if (val && col.params.display) {
                val = col.params.display;
            }
            else {
                val = '';
            }
        }
        else if (col.controlType === 'select2ajax') {
            if (val && val.display) {
                val = val.display;
            }
            else {
                val = '';
            }
        }
        return val;
    };
    ReadonlyService.prototype.setOptions = function (componentName, col) {
        var options = this.columnService.getRefOptions(componentName, col.key);
        if (options) {
            col = JSOG.parse(JSON.stringify(col));
            $.extend(true, col, { params: { options: options } });
        }
        return col;
    };
    ReadonlyService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ReadonlyService.ctorParameters = function () { return [
        { type: ColumnService }
    ]; };
    return ReadonlyService;
}());
export { ReadonlyService };
//# sourceMappingURL=readonly.service.js.map